export default __webpack_public_path__ + "static/media/animation-quiz.e3801061.gif";